(function () {
  if (window.csProductCollapsibleRowsLoaded) {
    if (window.csInitAllProductCollapsibleRows) {
      window.csInitAllProductCollapsibleRows(document);
    }
    return;
  }

  window.csProductCollapsibleRowsLoaded = true;

  function csNormalizeText(text) {
    return (text || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function csIsEmptyNode(node) {
    if (!node) return true;

    if (node.nodeType === 3) {
      return !csNormalizeText(node.textContent);
    }

    if (node.nodeType !== 1) return true;

    var text = csNormalizeText(node.textContent);
    var hasMedia = node.querySelector('img, iframe, video, svg, table, ul, ol');

    return !text && !hasMedia;
  }

  function csElementHasUnderlineStyle(element) {
    if (!element || element.nodeType !== 1) return false;

    var style = element.getAttribute('style') || '';

    return style.toLowerCase().indexOf('underline') !== -1;
  }

  function csHasUnderline(element) {
    if (!element || element.nodeType !== 1) return false;

    if (element.querySelector('u')) return true;

    if (csElementHasUnderlineStyle(element)) return true;

    var children = element.querySelectorAll('*');

    for (var i = 0; i < children.length; i++) {
      if (csElementHasUnderlineStyle(children[i])) {
        return true;
      }
    }

    return false;
  }

  function csCleanHeadingText(text) {
    return csNormalizeText(text).replace(/\s*:\s*$/, '');
  }

  function csHasLettersOrNumbers(text) {
    return /[A-Za-z0-9]/.test(text || '');
  }

  function csGetTextBeforeElement(root, target) {
    var range = document.createRange();

    try {
      range.setStart(root, 0);
      range.setEndBefore(target);
      return csNormalizeText(range.toString());
    } catch (error) {
      return '';
    }
  }

  function csGetFirstStrong(node) {
    if (!node || node.nodeType !== 1) return null;

    return node.querySelector('strong, b');
  }

  function csGetHeadingText(node, strongElement) {
    var textBeforeStrong = csGetTextBeforeElement(node, strongElement);
    var strongText = csNormalizeText(strongElement.textContent);
    var prefix = '';

    if (textBeforeStrong && !csHasLettersOrNumbers(textBeforeStrong)) {
      prefix = textBeforeStrong;
    }

    return csCleanHeadingText((prefix ? prefix + ' ' : '') + strongText);
  }

  function csIsStrongHeadingCandidate(node, strongElement) {
    if (!node || !strongElement) return false;

    var strongText = csNormalizeText(strongElement.textContent);

    if (!strongText || strongText.slice(-1) !== ':') {
      return false;
    }

    var textBeforeStrong = csGetTextBeforeElement(node, strongElement);

    return !csHasLettersOrNumbers(textBeforeStrong);
  }

  function csRemoveLeadingEmptyNodes(element) {
    if (!element) return;

    while (element.firstChild) {
      var first = element.firstChild;

      if (first.nodeType === 3 && !csNormalizeText(first.textContent)) {
        element.removeChild(first);
        continue;
      }

      if (first.nodeType === 1 && first.tagName && first.tagName.toLowerCase() === 'br') {
        element.removeChild(first);
        continue;
      }

      break;
    }
  }

  function csRemoveEmptyWrappers(element) {
    if (!element || element.nodeType !== 1) return;

    var wrappers = element.querySelectorAll('span, u, strong, b');

    wrappers.forEach(function (wrapper) {
      if (!csNormalizeText(wrapper.textContent) && !wrapper.children.length) {
        wrapper.remove();
      }
    });
  }

  function csRemoveCopiedUiNoise(element) {
    if (!element || element.nodeType !== 1) return;

    var removable = element.querySelectorAll(
      'script, style, .PDq2pG_selectionAnchor, [aria-hidden="true"].PDq2pG_selectionAnchor'
    );

    removable.forEach(function (item) {
      item.remove();
    });

    var allElements = element.querySelectorAll('*');

    allElements.forEach(function (item) {
      var className = item.getAttribute('class') || '';

      if (
        className.indexOf('qMYqUG_convSearchResultHighlightRoot') !== -1 ||
        className.indexOf('PDq2pG_selectionAnchorContainer') !== -1 ||
        className.indexOf('text-token-text-primary') !== -1 ||
        className.indexOf('agent-turn') !== -1 ||
        className.indexOf('threadScrollVars') !== -1
      ) {
        item.removeAttribute('class');
      }

      item.removeAttribute('data-start');
      item.removeAttribute('data-end');
      item.removeAttribute('data-turn-id');
      item.removeAttribute('data-turn-id-container');
      item.removeAttribute('data-is-intersecting');
      item.removeAttribute('data-testid');
      item.removeAttribute('data-turn');
      item.removeAttribute('data-conversation-screenshot-content');
      item.removeAttribute('dir');
    });
  }

  function csGetRemovableHeadingElement(strongElement, root) {
    var removable = strongElement;
    var headingText = csNormalizeText(strongElement.textContent);

    while (removable.parentNode && removable.parentNode !== root) {
      var parent = removable.parentNode;
      var parentText = csNormalizeText(parent.textContent);

      if (parentText === headingText && /^(span|u|strong|b)$/i.test(parent.tagName)) {
        removable = parent;
        continue;
      }

      break;
    }

    return removable;
  }

  function csCloneContentAfterHeading(node) {
    var clone = node.cloneNode(true);

    csRemoveCopiedUiNoise(clone);

    var strongElement = csGetFirstStrong(clone);

    if (!strongElement) return null;

    var removable = csGetRemovableHeadingElement(strongElement, clone);
    var parent = removable.parentNode;

    while (removable.previousSibling) {
      parent.removeChild(removable.previousSibling);
    }

    parent.removeChild(removable);

    csRemoveLeadingEmptyNodes(parent);
    csRemoveLeadingEmptyNodes(clone);
    csRemoveEmptyWrappers(clone);

    if (csIsEmptyNode(clone)) {
      return null;
    }

    return clone;
  }

  function csGetHeadingData(node) {
    if (!node || node.nodeType !== 1) return null;

    var tagName = node.tagName.toLowerCase();

    if (/^h[1-6]$/.test(tagName)) {
      var headingText = csCleanHeadingText(node.textContent);

      if (headingText) {
        return {
          heading: headingText,
          inlineContent: null
        };
      }
    }

    var strongElement = csGetFirstStrong(node);

    if (!strongElement) return null;

    var isUnderlineHeading = csHasUnderline(node);
    var isBoldColonHeading = csIsStrongHeadingCandidate(node, strongElement);

    if (!isUnderlineHeading && !isBoldColonHeading) {
      return null;
    }

    return {
      heading: csGetHeadingText(node, strongElement),
      inlineContent: csCloneContentAfterHeading(node)
    };
  }

  function csIsMainContentBlock(element) {
    if (!element || element.nodeType !== 1) return false;

    return /^(p|ul|ol|table|figure|blockquote|img|iframe|video|h1|h2|h3|h4|h5|h6|pre|hr)$/i.test(element.tagName);
  }

  function csCleanBlock(block) {
    if (!block || block.nodeType !== 1) return block;

    csRemoveCopiedUiNoise(block);
    csRemoveEmptyWrappers(block);

    return block;
  }

  function csCollectContentBlocks(node, blocks) {
    if (!node) return;

    if (node.nodeType === 11) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        csCollectContentBlocks(child, blocks);
      });

      return;
    }

    if (node.nodeType === 3) {
      if (csNormalizeText(node.textContent)) {
        var paragraph = document.createElement('p');
        paragraph.textContent = csNormalizeText(node.textContent);
        blocks.push(paragraph);
      }

      return;
    }

    if (node.nodeType !== 1) return;

    if (csIsMainContentBlock(node)) {
      var block = node.cloneNode(true);

      csCleanBlock(block);

      if (!csIsEmptyNode(block)) {
        blocks.push(block);
      }

      return;
    }

    Array.prototype.slice.call(node.childNodes).forEach(function (child) {
      csCollectContentBlocks(child, blocks);
    });
  }

  function csGetSourceBlocks(source) {
    var blocks = [];
    var nodes = [];

    if (source.content) {
      nodes = Array.prototype.slice.call(source.content.childNodes);
    } else {
      nodes = Array.prototype.slice.call(source.childNodes);
    }

    nodes.forEach(function (node) {
      csCollectContentBlocks(node, blocks);
    });

    return blocks;
  }

  function csTrimEmptyNodes(nodes) {
    while (nodes.length && csIsEmptyNode(nodes[0])) {
      nodes.shift();
    }

    while (nodes.length && csIsEmptyNode(nodes[nodes.length - 1])) {
      nodes.pop();
    }

    return nodes;
  }

  function csBuildRows(source) {
    var nodes = csGetSourceBlocks(source);
    var rows = [];
    var currentRow = null;

    nodes.forEach(function (node) {
      var headingData = csGetHeadingData(node);

      if (headingData) {
        if (currentRow) {
          currentRow.content = csTrimEmptyNodes(currentRow.content);

          if (currentRow.heading && currentRow.content.length) {
            rows.push(currentRow);
          }
        }

        currentRow = {
          heading: headingData.heading,
          content: []
        };

        if (headingData.inlineContent && !csIsEmptyNode(headingData.inlineContent)) {
          currentRow.content.push(headingData.inlineContent);
        }

        return;
      }

      if (currentRow) {
        currentRow.content.push(node);
      }
    });

    if (currentRow) {
      currentRow.content = csTrimEmptyNodes(currentRow.content);

      if (currentRow.heading && currentRow.content.length) {
        rows.push(currentRow);
      }
    }

    return rows;
  }

  function csCreateAccordionItem(row, index, openFirst) {
    var details = document.createElement('details');
    details.className = 'cs-product-collapsible-row';

    var summary = document.createElement('summary');
    summary.className = 'cs-product-collapsible-row__summary';

    var heading = document.createElement('span');
    heading.className = 'cs-product-collapsible-row__heading';
    heading.textContent = row.heading;

    var icon = document.createElement('span');
    icon.className = 'cs-product-collapsible-row__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '+';

    var content = document.createElement('div');
    content.className = 'cs-product-collapsible-row__content rte';

    var inner = document.createElement('div');
    inner.className = 'cs-product-collapsible-row__content-inner';

    row.content.forEach(function (node) {
      inner.appendChild(node.cloneNode(true));
    });

    content.appendChild(inner);

    summary.appendChild(heading);
    summary.appendChild(icon);

    details.appendChild(summary);
    details.appendChild(content);

    if (openFirst && index === 0) {
      details.setAttribute('open', '');
      content.style.height = 'auto';
    } else {
      content.style.height = '0px';
    }

    return details;
  }

  function csOpenItem(item) {
    if (!item || item.open || item.classList.contains('cs-product-collapsible-row--animating')) return;

    var content = item.querySelector('.cs-product-collapsible-row__content');
    if (!content) return;

    item.setAttribute('open', '');
    item.classList.add('cs-product-collapsible-row--animating');

    content.style.height = '0px';
    content.offsetHeight;

    requestAnimationFrame(function () {
      content.style.height = content.scrollHeight + 'px';
    });

    content.addEventListener('transitionend', function handler(event) {
      if (event.target !== content || event.propertyName !== 'height') return;

      content.style.height = 'auto';
      item.classList.remove('cs-product-collapsible-row--animating');
      content.removeEventListener('transitionend', handler);
    });
  }

  function csCloseItem(item) {
    if (!item || !item.open || item.classList.contains('cs-product-collapsible-row--animating')) return;

    var content = item.querySelector('.cs-product-collapsible-row__content');
    if (!content) return;

    item.classList.add('cs-product-collapsible-row--animating');

    content.style.height = content.scrollHeight + 'px';
    content.offsetHeight;

    requestAnimationFrame(function () {
      content.style.height = '0px';
    });

    content.addEventListener('transitionend', function handler(event) {
      if (event.target !== content || event.propertyName !== 'height') return;

      item.removeAttribute('open');
      item.classList.remove('cs-product-collapsible-row--animating');
      content.removeEventListener('transitionend', handler);
    });
  }

  function csEnableAccordionBehavior(output, singleOpen) {
    var items = output.querySelectorAll('.cs-product-collapsible-row');

    items.forEach(function (item) {
      var summary = item.querySelector('.cs-product-collapsible-row__summary');

      if (!summary) return;

      summary.addEventListener('click', function (event) {
        event.preventDefault();

        if (item.open) {
          csCloseItem(item);
          return;
        }

        if (singleOpen) {
          items.forEach(function (otherItem) {
            if (otherItem !== item && otherItem.open) {
              csCloseItem(otherItem);
            }
          });
        }

        csOpenItem(item);
      });
    });
  }

  function csShowFallback(fallback, output, empty) {
    if (fallback) fallback.hidden = false;

    if (output) {
      output.hidden = true;
      output.innerHTML = '';
    }

    if (empty) empty.hidden = false;
  }

  function csShowAccordion(fallback, output, empty) {
    if (fallback) fallback.hidden = true;
    if (output) output.hidden = false;
    if (empty) empty.hidden = true;
  }

  function csInitAccordion(container) {
    if (!container || container.dataset.csInitialized === 'true') return;

    var source = container.querySelector('[data-cs-accordion-source]');
    var output = container.querySelector('[data-cs-accordion-output]');
    var fallback = container.querySelector('[data-cs-accordion-fallback]');
    var empty = container.querySelector('[data-cs-accordion-empty]');

    var openFirst = container.dataset.csOpenFirst === 'true';
    var singleOpen = container.dataset.csSingleOpen === 'true';

    if (!source || !output) return;

    try {
      var rows = csBuildRows(source);

      output.innerHTML = '';

      if (!rows || rows.length < 2) {
        csShowFallback(fallback, output, empty);
        container.dataset.csInitialized = 'true';
        return;
      }

      rows.forEach(function (row, index) {
        output.appendChild(csCreateAccordionItem(row, index, openFirst));
      });

      csEnableAccordionBehavior(output, singleOpen);
      csShowAccordion(fallback, output, empty);

      container.dataset.csInitialized = 'true';
    } catch (error) {
      csShowFallback(fallback, output, empty);
      container.dataset.csInitialized = 'true';
    }
  }

  function csInitAllAccordions(scope) {
    var accordions = (scope || document).querySelectorAll('[data-cs-product-accordion]');

    accordions.forEach(function (accordion) {
      csInitAccordion(accordion);
    });
  }

  function csInitFromAddedNode(node) {
    if (!node || node.nodeType !== 1) return;

    if (node.matches && node.matches('[data-cs-product-accordion]')) {
      csInitAccordion(node);
    }

    csInitAllAccordions(node);
  }

  function csStartMutationObserver() {
    if (!window.MutationObserver) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.slice.call(mutation.addedNodes).forEach(function (node) {
          csInitFromAddedNode(node);
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function csBoot() {
    csInitAllAccordions(document);

    setTimeout(function () {
      csInitAllAccordions(document);
    }, 250);

    setTimeout(function () {
      csInitAllAccordions(document);
    }, 1000);
  }

  window.csInitAllProductCollapsibleRows = csInitAllAccordions;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', csBoot);
  } else {
    csBoot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    csInitAllAccordions(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    csInitAllAccordions(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    csInitAllAccordions(event.target);
  });

  document.addEventListener('quick-view:open', function () {
    csInitAllAccordions(document);
  });

  document.addEventListener('modal:open', function () {
    csInitAllAccordions(document);
  });

  csStartMutationObserver();
})();